import { Link } from "react-router-dom";
import { routesMap } from "@/components/routes/routes";
import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import OpticksLogo from "@/components/ui/OpticksLogos/OpticksLogo";

const TrialEmailVerificationPending = () => (
  <>
    <OpticksLogo />
    <h2>Please verify your email</h2>

    <div className="fields">
      <p>
        We’ve sent a verification link to your email address.
        <br />
        Check your inbox to activate your account and start using the platform.
      </p>
      <br />
      <p>
        Didn’t get the email? <br />
        Contact our support team at{" "}
        <OpticksLink
          href="mailto:support@optickssecurity.com"
          label="support@optickssecurity.com"
        />
        <br />
        <br />
        <Link to={routesMap.auth.login.path}>Go to Login</Link>
      </p>
    </div>
  </>
);

export default TrialEmailVerificationPending;
